import React from "react";
import Testimonial from "../components/Testimonial";
import Stats from "../components/Stats";

const Home = () => {
  return (
    <div>
      <Stats />
      <Testimonial />
    </div>
  );
};

export default Home;
